import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {sensor} from "../models/sensor";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class SensorService {

  private sensorToEdit: sensor = null;

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/sensor/getall');
  }

  public getByIdEmpresa(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa", idEmpresa);
    return this.http.getWithParams('/sensor/getbyidempresa', params);
  }

  getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto", idProyecto);
    return this.http.getWithParams('/sensor/getbyidproyecto', params);
  }

  getSensorData(MAC: string) {
    let params = new HttpParams().set("MAC", MAC);
    return this.http.getWithParams('/sensor/getsensordata', params);
  }

  public getSensorDataPaginated(sensorID: string, page: number, sortAscending: boolean) {
    let params = new HttpParams().set("sensorID",sensorID).set("page",page + "")
      .set("sortAscending",sortAscending + "");
    return this.http.getWithParams('/sensor/getsensordatapaginated', params);
  }

  public getCountForSensorDataPaginated(sensorID: string) {
    let params = new HttpParams().set("sensorID",sensorID);
    return this.http.getWithParams('/sensor/getcountforsensordatapaginated', params);
  }


  getSensorDataByTimestamps(MAC, time_init, time_end, interval) {
    let params = new HttpParams().set("idDispositivo", MAC)
      .set("time_init", time_init)
      .set("time_end", time_end)
      .set("interval", interval);
    return this.http.getWithParams('/sensor/getsensordatabytimestamps', params);
  }

  updateSensor(sensor: sensor) {
    return this.http.patch('/sensor/updatesensor', sensor)
  }

  public setSensorToEdit(sensor: sensor) {
    this.sensorToEdit = sensor;
  }

  public getSensorToEdit() {
    return this.sensorToEdit;
  }

  public infoUpdate(idDispositivo: string, nombre: string) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "nombre": nombre,
      };
    return this.http.patch('/sensor/infoupdate', body);
  }

  public getSensoresPresenciaByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/sensor/getsensorespresenciabyidproyecto', params);
  }

  public getSensores420ByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/sensor/getsensores420byidproyecto', params);
  }

  public deleteRegistry(idDispositivo: string) {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.post('/sensor/deleteregistry', body);
  }

  public addSensorsFromCSV(idUser, sensors) {

    let json =
      {
        "idUser": idUser,
        "sensors": sensors
      };

    return this.http.post('/sensor/addsensorsfromcsv', JSON.stringify(json));
  }

  downloadSensorsCSV() {
    return this.http.getText('/sensor/download-sensors-csv');
  }

}
